import request from "../utils/request";

/**
 * 获取抽奖活动
 * @returns 
 */
export function getActivityinfo(activityId) {
    return request.post("/activity/info", { activityId: activityId });
}

/**
 * 获取抽奖活动集合
 * @returns 
 */
export function getLatestActivity() {
    return request.post("/activity/latestActivity");
}

/**
 * 加载抽奖奖品列表
 * @param {*} form 
 * @returns 
 */
export function findCardListByActivityId(form) {
    return request.post("/activity/findCardByActivityId", form);
}
/**
 * 获取抽奖结果
 * @param {*} form 
 * @returns 
 */
export function getLotteryByActivityId(form) {
    return request.post("/activity/lottery", form);
}

/**
 * 是否有新年活动
 * @returns 
 */
export function loadNewYear() {
    return request.post("/activity/loadNewYear");
}

/**
 * 周年庆活动
 * @returns 
 */
export function loadSeven(ignoreCust) {
    return request.post("/activity/loadSeven", { ignoreCust: ignoreCust });
}

/**
 * 获取用户和投资报告信息
 * @returns 
 */
export function getCustAndInvsetInfo() {
    return request.post("/activity/getCustAndInvsetInfo");
}

/**
 * 更新用户已阅读活动详情
 * @param {*} activityId 
 * @returns 
 */
export function updateSevenList(activityId) {
    return request.post("/activity/updateSevenList", { activityId: activityId })
}

/**
 * 获取用户活动期间累计年化投资金额
 * @returns 
 */
export function getYearAmount() {
    return request.post("/activity/getYearAmount");
}

export function getDiscountYearAmount() {
    return request.post("/activity/getDiscountYearAmount");
}

/**
 * 加载4月活动
 * @param {*} orderId 
 * @returns 
 */
export function loadAprilOuting() {
    return request.post("/activity/aprilOuting/loadAprilOuting")
}

/**
 * 获取活动抽奖项
 * @param {*} activityId 
 * @returns 
 */
export function getCard(activityId) {
    return request.post("/activity/aprilOuting/card", { activityId: activityId })
}

/**
 * 活动抽奖
 * @param {*} activityId 
 * @returns 
 */
export function lottery(activityId) {
    return request.post("/activity/aprilOuting/lottery", { activityId: activityId })
}

/**
 * 抽奖提示关闭
 * @returns 
 */
export function noticed() {
    return request.post("/activity/aprilOuting/noticed")
}

export function aprilRedPacket() {
    return request.post("/activity/aprilOuting/aprilRedPacket")
}

export function mayNoticed() {
    return request.post("/activity/may/noticed")
}

export function mayGrantMayRedPacket() {
    return request.post("/activity/may/grantMayRedPacket")
}

export function mayTotalAmount() {
    return request.post("/activity/may/totalAmount")
}

export function juneLoad() {
    return request.post("/activity/june/load")
}

export function junePreNotice() {
    return request.post("/activity/june/preNotice")
}

export function juneCard(activityId) {
    return request.post("/activity/june/card", { activityId: activityId })
}

export function juneLottery() {
    return request.post("/activity/june/lottery")
}

export function junePostNotice(orderId) {
    return request.post("/activity/june/postNotice", { orderId: orderId })
}

export function activityNotice() {
    return request.post("/activity/notice")
}

export function activityRead(noticeId) {
    return request.post("/activity/read", { noticeId: noticeId })
}

export function julyLoad() {
    return request.post("/activity/july/load")
}

// 参数：type，1：加息劵，3：满减券
export function julyLottery(type) {
    return request.post("/activity/july/lottery", { type: type })
}

export function shakeLottery() {
    return request.post("/activity/shake/lottery")
}

export function valentineCheck(productId) {
    return request.post("/activity/valentine/check", { productId: productId })
}

export function midautumnLoad() {
    return request.post("/activity/midautumn/load")
}

export function subjectQuestion(params) {
    return request.post("/activity/subject/question", params)
}

export function subjectAnswer(params) {
    return request.post("/activity/subject/answer", params)
}

export function midautumnLottery() {
    return request.post("/activity/midautumn/lottery")
}

export function midautumnPhoneCharge(params) {
    return request.post("/activity/midautumn/phoneCharge", params)
}

export function midautumnPrize(activityId) {
    return request.post("/activity/midautumn/prize", { activityId: activityId })
}

export function midautumnShare(activityId) {
    return request.post("/activity/midautumn/share", { activityId: activityId })
}

/**
 * 领取通知查询
 * @returns 
 */
export function novCheck() {
    return request.post("/activity/nov/check")
}

/**
 * 领取加息券
 * @param {*} id 
 * @returns 
 */
export function novReward(id) {
    return request.post("/activity/nov/reward", { id: id })
}

export function decAnnualYearAmount() {
    return request.post("/activity/dec/annualYearAmount")
}

export function yuandanRedList() {
    return request.post("/activity/yuandan/redlist")
}

export function yuandanGrant() {
    return request.post("/activity/yuandan/grant")
}

export function yuandan26RedList() {
    return request.post("/activity/yuandan2026/redlist")
}

export function yuandanGrant26(ids) {
    return request.post("/activity/yuandan2026/award", { ids: ids })
}